import * as ko from 'knockout';

import * as traitCategoriesApi from '../api/trait_categories';
import { I18nText } from '../i18n_text';
import { DriverData } from '../api/drivers';
import { getDriverSearchConfig } from '../components/configs/search_configs';
import { SlugGenerator } from '../ko_bindings/slug_validation';

export class TraitCategory {
  private slugGenerator: SlugGenerator;

  id = ko.observable<string>(null);
  code = ko.observable<string>('').extend({
    required: true,
    serverError: true,
  });
  nameJson = ko.observable<I18nText>().extend({
    i18nTextRequired: true,
    serverError: true,
  });
  driver = ko.observable<DriverData>(null);

  driverSearchConfig = getDriverSearchConfig(this.driver);

  editUrl = ko.pureComputed(() => {
    return '/trait_categories/' + this.id() + '/';
  });

  constructor(data?: traitCategoriesApi.TraitCategoryData) {
    if (data) {
      this.id(data.id);
      this.nameJson(data.name_json);
      this.driver(data.driver);
      this.code(data.code);
    }

    this.slugGenerator = new SlugGenerator(this.nameJson, null, this.code, {
      canEdit: !this.id(),
      fillIfEmpty: true,
    });
  }

  toData(): traitCategoriesApi.TraitCategoryData {
    return {
      id: this.id(),
      name_json: this.nameJson(),
      driver: this.driver(),
      code: this.code(),
    };
  }

  dispose() {
    this.slugGenerator.dispose();
  }
}
